export const environment = {
  production: true,
  BUILT_AT: "2026-1-28 8:39:9",
};
